<template>
  <div data-qa="supplementarydocuments-div-4jmzv">
    <!-- TOAST -->
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      app
      top
      right
      width="600"
      :color="'#FEF8F9'"
      data-qa="supplementarydocuments-snackbar-yky85"
    >
      <v-btn
        icon
        @click="snackbar = false"
        class="float-right"
        data-qa="supplementarydocuments-btn-0i3d99"
      >
        <v-icon
          color="black"
          class="material-symbols-outlined"
          data-qa="supplementarydocuments-icon-z70n9"
        >
          close
        </v-icon>
      </v-btn>
      <v-row data-qa="supplementarydocuments-row-9pieex">
        <v-col cols="2" class="d-flex justify-center" data-qa="supplementarydocuments-col-hdt2c">
          <v-icon
            color="red"
            class="material-symbols-outlined"
            data-qa="supplementarydocuments-icon-76diy6"
          >
            error
          </v-icon>
        </v-col>
        <v-col cols="10" class="black--text" data-qa="supplementarydocuments-col-fz3l9">
          <div class="text-subtitle-1 font-weight-bold" data-qa="supplementarydocuments-div-ntmvk">
            {{ resource.toast.title }}
          </div>
          <div class="text-subtitle-1" data-qa="supplementarydocuments-div-bsskb4">
            {{ resource.toast.line1 }}
          </div>
          <div class="text-subtitle-1" data-qa="supplementarydocuments-div-d0j8s8">
            {{ resource.toast.line2 }}
          </div>
        </v-col>
      </v-row>
    </v-snackbar>

    <!-- This file input is not displayed but triggered when DRAG AND DROP card is clicked -->
    <v-file-input
      v-model="selectedFiles"
      ref="fileInput"
      multiple
      label="File input"
      @change="handleSelectedFiles"
      class="hide-file-input"
      data-qa="supplementarydocuments-file-input-4szj8"
    />

    <!-- DRAG AND DROP -->
    <div
      class="text-subtitle-1"
      :class="{ 'text-disabled': cardDisabled }"
      data-qa="supplementarydocuments-title"
    >
      {{ documentsRequired ? resource.title : resource.titleOptional }}
    </div>
    <v-hover v-slot="{ hover }" data-qa="supplementarydocuments-hover-ym7rxg">
      <v-card
        outlined
        :disabled="cardDisabled"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        @click.native="openFileExplorer"
        class="drag-and-drop-border-dash rounded-border w-100"
        :class="{
          'drag-and-drop-border-solid': dragover || hover,
          'drag-and-drop-disabled': cardDisabled
        }"
        data-qa="supplementarydocuments-card-lin0vw"
      >
        <v-container data-qa="supplementarydocuments-container-u1zu6">
          <v-card-text data-qa="supplementarydocuments-card-text-v1z4hl">
            <v-row data-qa="supplementarydocuments-row-cikf9">
              <v-col cols="2" class="d-flex align-center justify-center">
                <v-icon
                  size="60"
                  :color="cardDisabled ? 'gray' : primaryColor"
                  class="mt-5"
                  data-qa="supplementarydocuments-icon-aph273"
                >
                  mdi-paperclip
                </v-icon>
              </v-col>
              <v-col cols="10">
                <div
                  class="text-subtitle-1 font-weight-bold mb-4"
                  data-qa="supplementarydocuments-div-a72mbs"
                >
                  {{ resource.note }}
                </div>
                <div class="text-caption" data-qa="supplementarydocuments-div-unw70j">
                  {{ resource.allowedFiles }}
                </div>
                <div class="text-caption" data-qa="supplementarydocuments-div-0lbjd">
                  {{ resource.maxFiles }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>
      </v-card>
    </v-hover>

    <!-- DOCUMENT LIST -->
    <v-container class="px-0">
      <transition-group name="list" tag="div">
        <v-card
          v-for="(file, idx) in supplementaryDocuments"
          :key="file.id"
          flat
          class="w-100"
          :class="{ 'red-border': file.error }"
          :data-qa="`supplementarydocuments-div-7ekmfp-${idx}`"
        >
          <!-- FULL  V I E W -->
          <template v-if="!compactView">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="1" class="d-flex justify-center align-center">
                  <v-icon>mdi-attachment</v-icon>
                </v-col>
                <v-col cols="12" sm="6"  class="d-flex flex-column">
                  <span
                    v-text="file.name"
                    class="text-subtitle-2 font-weight-bold"
                    style="word-break: break-word;"
                  />
                  <span v-text="file.displaySize" class="text-caption" />
                </v-col>
                <v-col cols="12" sm="4" class="d-flex justify-center align-center">
                  <span
                    v-if="file.error"
                    v-text="file.error"
                    class="text-body-2 red--text"
                    style="word-break: break-word;"
                  />
                </v-col>
                <v-col cols="12" sm="1" class="d-flex justify-center align-center">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      icon
                      @click="removeFile(idx)"
                      :data-qa="`supplementarydocuments-btn-ia39ych-${idx}`"
                    >
                      <v-icon
                        :color="hover ? 'red' : 'gray'"
                        :class="['material-symbols-outlined', { 'rotate-on-hover': hover }]"
                        :data-qa="`supplementarydocuments-icon-ftcmv6-${idx}`"
                      >
                        cancel
                      </v-icon>
                    </v-btn>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card-text>
          </template>

          <!-- C O M P A C T  V I E W -->
          <template v-else>
            <v-card-text class="pa-2">
              <v-row no-gutters>
                <v-col cols="11" class="d-flex flex-column">
                  <span
                    v-text="file.name"
                    class="text-subtitle-2 font-weight-bold"
                    style="word-break: break-word;"
                  />
                  <span
                    v-text="file.displaySize"
                    class="text-caption"
                  />
                  <span
                    v-if="file.error"
                    v-text="file.error"
                    class="text-body-2 red--text"
                  />
                </v-col>
                <v-col cols="1" class="d-flex justify-center align-center">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      icon
                      @click="removeFile(idx)"
                      :data-qa="`supplementarydocuments-btn-ia39ych-${idx}`"
                    >
                      <v-icon
                        :color="hover ? 'red' : 'gray'"
                        :class="['material-symbols-outlined', { 'rotate-on-hover': hover }]"
                        :data-qa="`supplementarydocuments-icon-ftcmv6-${idx}`"
                      >
                        cancel
                      </v-icon>
                    </v-btn>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </v-card>
      </transition-group>
    </v-container>
  </div>
</template>

<script>
import uuid from 'uuid-random'

export default {
  name: 'SupplementaryDocuments',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxFileSizeInMB: {
      type: Number
    },
    maxFileUploadCount: {
      type: Number
    },
    validFileTypes: {
      type: Array
    },
    required: {
      type: Boolean
    },
    compactView: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedFiles: [],
    dragover: false,
    snackbar: false
  }),
  methods: {
    handleSelectedFiles () {
      if (this.selectedFiles.length + this.supplementaryDocuments.length > this.maxUploadCount) {
        this.snackbar = true
        return
      }
      this.addToSupplementaryDocuments(this.selectedFiles)
      this.selectedFiles = []
    },
    hasValidExtension (filename) {
      const ext = filename.split('.').pop()
      return this.validTypes.includes(ext.toLowerCase())
    },
    formatFileSize (bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    },
    onDrop (e) {
      this.dragover = false
      this.snackbar = false

      const files = Array.from(e.dataTransfer.files)
      if (this.supplementaryDocuments.length + files.length > this.maxUploadCount) {
        this.snackbar = true
        return
      }
      this.addToSupplementaryDocuments(e.dataTransfer.files)
    },
    addToSupplementaryDocuments (files) {
      this.supplementaryDocuments.push(...files)
      this.supplementaryDocuments.forEach(file => {
        file.id = file?.id ?? uuid()
        file.displaySize = this.formatFileSize(file.size)
        file.fileName = file.name
      })
      this.validateFiles()
      this.updateModel()
    },
    validateFile (file) {
      if (!this.hasValidExtension(file.name)) {
        return `${this.resource.invalidFile}`
      }
      if (file.size > this.maxSizeInBytes) {
        return `${this.resource.fileExceedsSize}`
      }
      return null
    },
    removeFile (indexToRemove) {
      this.supplementaryDocuments.splice(indexToRemove, 1)
      this.validateFiles()
      this.updateModel()
    },
    openFileExplorer () {
      this.$refs.fileInput.$el.querySelector('input').click()
    },
    updateModel () {
      this.$emit('input', this.supplementaryDocuments)
    },
    validateFiles () {
      const mapName = new Map()
      this.supplementaryDocuments.forEach(file => {
        const { name } = file
        if (mapName.has(name)) {
          file.error = this.resource.fileExists
        } else {
          file.error = this.validateFile(file)
          mapName.set(name, true)
        }
      })
    }
  },
  computed: {
    resource () {
      return {
        title: this.$t('supplementaryDocuments.title'),
        titleOptional: this.$t('supplementaryDocuments.titleOptional'),
        note: this.$t('supplementaryDocuments.note'),
        allowedFiles: this.$t('supplementaryDocuments.allowedFiles', { validFileTypes: this.validFileTypesText, size: this.maxSize }),
        maxFiles: this.$t('supplementaryDocuments.maxFiles', { limit: this.maxUploadCount }),
        selectFiles: this.$t('supplementaryDocuments.selectFiles'),
        toast: {
          title: this.$t('supplementaryDocuments.toast.title'),
          line1: this.$t('supplementaryDocuments.toast.line1'),
          line2: this.$t('supplementaryDocuments.toast.line2')
        },
        invalidFile: this.$t('supplementaryDocuments.error.invalidFile'),
        fileExceedsSize: this.$t('supplementaryDocuments.error.fileExceedsSize', {
          size: this.maxSize
        }),
        fileExists: this.$t('supplementaryDocuments.error.fileExists')
      }
    },
    cardDisabled () {
      return this.supplementaryDocuments.length === this.maxUploadCount
    },
    maxSize () {
      return (
        this.maxFileSizeInMB ??
        this.$appSettings.defaultConfigurations.supplementaryDocuments.maxFileSizeInMB
      )
    },
    maxSizeInBytes () {
      return this.maxSize * 1024 * 1024
    },
    maxUploadCount () {
      return (
        this.maxFileUploadCount ??
        this.$appSettings.defaultConfigurations.supplementaryDocuments.maxFileUploadCount
      )
    },
    validTypes () {
      return (
        this.validFileTypes ??
        this.$appSettings.defaultConfigurations.supplementaryDocuments.validFileTypes
      )
    },
    documentsRequired () {
      return (
        this.required ?? this.$appSettings.defaultConfigurations?.supplementaryDocuments?.required
      )
    },
    supplementaryDocuments () {
      return this.value
    },
    validFileTypesText () {
      return this.validTypes.map(ext => ext.toUpperCase()).join(', ')
    }
  }
}
</script>

<style scoped>
.hide-file-input {
  display: none;
}
.red-border {
  border: 2px solid red;;
  border-radius: 10px;
}
.rounded-border {
  border-radius: 15px;
}
.drag-and-drop-border-dash {
  border: 2px dashed #694ed666;
}
.drag-and-drop-border-solid {
  border: 2px solid #694ed6;
  background-color: #f0eff7;
}
.drag-and-drop-disabled {
  border: 2px dashed gray;
}
.error {
  color: #d60040;
}
.text-disabled {
  color: gray;
}
.rotate-on-hover {
  transition: transform 0.5s;
  transform: rotate(180deg);
  color: red;
}
.list-leave-active {
  transition: all 0.5s ease-out;
  transform: translateX(30px);
  opacity: 0;
}
</style>
